'use client';

export { default } from './Hidden';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Hidden/index.js
// module id = 927
// module chunks = 25